import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
  GridSelectionChangeEvent,
  GridHeaderSelectionChangeEvent,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { getter, Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import {
  getSelectedState,
  HeaderThElement,
} from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../components/layout/Loading";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import IconButton from "../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import {
  ActiveInactiveContact,
  assignContactToUser,
  bulkUploadContacts,
  deleteContact,
  downloadContactExcel,
  getAllContacts,
} from "./services/contact.services";
import {
  clearContactFilterDetails,
  clearContactID,
  setactiveTabIndex,
  setContactFilterDetails,
  setContactID,
} from "./contactSlice";
import { checkAcessRights } from "../../_helper/helper";
import {
  CONTACTSORTTYPE,
  CONTACTTYPE,
  DELETE_ACCESS,
  EDIT_ACCESS,
  EXCEL_EXPORT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { getAllActiveUsers } from "../user/services/user.services";
import { IUser } from "../user/userModel";
import { ErrorToast } from "../../components/toast/Toasts";
import ContactFilter from "./ContactFilter";
import { Switch } from "@progress/kendo-react-inputs";
import { FiEdit } from "react-icons/fi";
import { LiaInfoSolid } from "react-icons/lia";
import { TbReceiptRupee } from "react-icons/tb";
import { IoMdPersonAdd } from "react-icons/io";
import { BsBookmarkPlusFill } from "react-icons/bs";
import {
  clearCurrentPage,
  setCurrentPage,
  setPageLimit,
} from "../pagination/paginationSlice";
import ButtonCreate from "../../components/drawer/ButtonCreate";
import { RxCross1 } from "react-icons/rx";
import FormFileUpload from "../../components/formFields/FormFileUpload";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import contactSample from "../../assets/Excels/contact_sample.xlsx";
import { MdKeyboardBackspace } from "react-icons/md";
import FormDatePicker from "../../components/formFields/FormDateField";
import moment from "moment";
import { saveAs } from "file-saver";
import { requiredValidator } from "../../components/formFields/CommonValidator";

const Contact: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  const isExcelAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS
  );

  const handleOpenBulkUploadDialog = () => {
    dispatch(openDialog("bulkUploadContact"));
  };

  const handleOpenExcelDownloadDialog = () => {
    dispatch(openDialog("filterforexceldownload"));
  };

  return (
    <>
      <DeleteContactDialog />
      <BulkUploadContactDialog />
      <ExcelDownloadDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0px 20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <IconButton
              fillMode="solid"
              title="Back"
              onClick={() => navigate(-1)}
              icon={MdKeyboardBackspace}
              iconClassName="absolute-position"
              style={{ height: 30 }}
              iconStyle={{ fontSize: "20px" }}
            />
            <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
              Contact List
            </Typography.h4>
          </div>
          <div>
            {isExcelAccess && (
              <Button
                themeColor={"primary"}
                fillMode={"solid"}
                style={{ marginRight: 10 }}
                onClick={() => handleOpenExcelDownloadDialog()}
              >
                Excel Download
              </Button>
            )}
            {isAddAccess && (
              <Button
                themeColor={"primary"}
                fillMode={"solid"}
                style={{ marginRight: 10 }}
                onClick={() => handleOpenBulkUploadDialog()}
              >
                Bulk Upload
              </Button>
            )}
            {isAddAccess && (
              <ButtonCreate label="Add New" drawerName="contactForm" />
            )}
          </div>
        </GridLayoutItem>
        <GridLayoutItem>
          <ContactGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const ContactGridComponent: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  //   const isAddAccess = checkAcessRights("/inquiry", INSERT_ACCESS);
  const isEditBtnRef = useRef<any>(false);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);

  const ContactList = useAppSelector((state) => state.contact.ContactList);
  const activeTabIndex = useAppSelector(
    (state) => state.contact.activeTabIndex
  );
  const loading = useAppSelector((state) => state.contact.loading);
  const UserList = useAppSelector((state) => state.user.UserList);
  const ContactFilterDetails = useAppSelector(
    (state) => state.contact.ContactFilterDetails
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const [selectedState, setSelectedState] = React.useState<{
    [id: string]: boolean | number[];
  }>({});
  const [rowSelectionModel, setRowSelectionModel] = React.useState<number[]>(
    []
  );

  useEffect(() => {
    const payload = {
      filterName: ContactFilterDetails?.filterName,
      filterMobileNo: ContactFilterDetails?.filterMobileNo,
      filterEmailID: ContactFilterDetails?.filterEmailID,
      filterContactType: ContactFilterDetails?.filterContactType,
      filterFromDate: ContactFilterDetails?.filterFromDate,
      filterToDate: ContactFilterDetails?.filterToDate,
      filterUnassignedContacts: ContactFilterDetails?.filterUnassignedContacts,
      SortType: ContactFilterDetails?.SortType,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(getAllContacts(payload));
  }, [ContactFilterDetails, activeTabIndex, pageLimit, currentPage]);

  useEffect(() => {
    setSelectedState({});
    setRowSelectionModel([]);
  }, [ContactList]);

  useEffect(() => {
    dispatch(getAllActiveUsers());
    return () => {
      dispatch(closeDialog());
      if (!isEditBtnRef.current) {
        dispatch(clearContactFilterDetails());
      }
    };
  }, []);

  const dataState = ContactList?.map((dataItem: any) =>
    Object.assign({ selected: false }, dataItem)
  );

  const DATA_ITEM_KEY: string = "ID";
  const SELECTED_FIELD: string = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const onSelectionChange = React.useCallback(
    (event: GridSelectionChangeEvent) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState: selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });
      setSelectedState(newSelectedState);
      const trueKeys = Object.keys(newSelectedState)
        .filter((key) => newSelectedState[key])
        .map(Number);
      setRowSelectionModel(trueKeys);
    },
    [selectedState]
  );

  const onHeaderSelectionChange = React.useCallback(
    (event: GridHeaderSelectionChangeEvent) => {
      const checkboxElement: any = event.syntheticEvent.target;
      const checked = checkboxElement.checked;
      const newSelectedState: { [key: string]: boolean } = {};

      event?.dataItems?.forEach((item: any) => {
        newSelectedState[idGetter(item)] = checked;
      });
      setSelectedState(newSelectedState);
      const trueKeys = Object.keys(newSelectedState)
        .filter((key: string) => newSelectedState[key])
        .map(Number);
      setRowSelectionModel(trueKeys);
    },
    []
  );

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleEditContact = (ID: number) => {
      navigate("/contact/edit", { state: { ContactID: ID } });
    };

    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteContact"));
      dispatch(setContactID(ID));
    };

    return (
      <td
        className={`action-td ${props.className}`}
        style={{ ...props.style, right: 0 }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() => {
              isEditBtnRef.current = true;
              handleEditContact(props.dataItem.ID);
            }}
            icon={FiEdit}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
      </td>
    );
  };

  const ListingButtonCell = (props: GridCellProps) => {
    const handleLeads = (ID: number) => {
      navigate("/lead", { state: { ContactID: ID } });
    };
    const handleInquiries = (ID: number) => {
      navigate("/inquiry", { state: { ContactID: ID } });
    };
    const handleQuotations = (ID: number) => {
      navigate("/quotation", { state: { ContactID: ID } });
    };
    const handleBookings = (ID: number) => {
      navigate("/tourbooking", { state: { ContactID: ID } });
    };

    return (
      <td
        className={`action-td ${props.className}`}
        style={{ ...props.style, right: 110 }}
      >
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Leads"
          themeColor="primary"
          style={{ marginRight: 5 }}
          onClick={() => handleLeads(props.dataItem.ID)}
          icon={IoMdPersonAdd}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "22px" }}
        />
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Inquiries"
          themeColor="info"
          style={{ marginRight: 5 }}
          onClick={() => handleInquiries(props.dataItem.ID)}
          icon={LiaInfoSolid}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Quotations"
          themeColor="success"
          style={{ marginRight: 5 }}
          onClick={() => handleQuotations(props.dataItem.ID)}
          icon={TbReceiptRupee}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
        {false && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Bookings"
            themeColor="tertiary"
            onClick={() => handleBookings(props.dataItem.ID)}
            icon={BsBookmarkPlusFill}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
      </td>
    );
  };

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(props.dataItem.IsActive);

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        ID: props.dataItem.ID,
        IsActive: !IsActive,
      };
      dispatch(ActiveInactiveContact(data)).then((response: any) => {
        if (response.payload?.data?.Status === 200) {
          dispatch(
            getAllContacts({
              ...ContactFilterDetails,
              limit: +pageLimit,
              skip: +currentPage * +pageLimit,
            })
          );
        } else {
          dispatch(
            getAllContacts({
              ...ContactFilterDetails,
              limit: +pageLimit,
              skip: +currentPage * +pageLimit,
            })
          );
        }
      });
    };

    return (
      <td
        className={props.className}
        style={{ textAlign: "center", ...props.style, right: 300 }}
      >
        <Switch
          disabled={isEditAccess ? false : true}
          name="IsActive"
          checked={IsActive}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${
        props.index === 8 || props.index === 6 || props.index === 7
          ? "locked-header"
          : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const handleTabChange = (index: number) => {
    dispatch(clearCurrentPage());
    dispatch(setactiveTabIndex(index));
    dispatch(
      setContactFilterDetails({
        ...ContactFilterDetails,
        filterUnassignedContacts: index === 1 ? true : false,
      })
    );
  };

  const handleSortChange = (value: number) => {
    dispatch(clearCurrentPage());
    dispatch(
      setContactFilterDetails({
        ...ContactFilterDetails,
        SortType: value || "CreatedOnDesc",
      })
    );
  };

  const handleSubmit = async (
    values: any,
    formRenderProps: FormRenderProps
  ) => {
    if (rowSelectionModel?.length < 1) {
      ErrorToast("Please select atleast one!!!");
    } else {
      try {
        const payload = {
          ContactID: rowSelectionModel ? rowSelectionModel?.join(", ") : "",
          UserID: values?.User ? +values?.User : null,
        };
        const response = await dispatch(assignContactToUser(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          formRenderProps.onChange("User", { value: null });
          dispatch(
            getAllContacts({
              ...ContactFilterDetails,
              limit: +pageLimit,
              skip: +currentPage * +pageLimit,
            })
          );
          // dispatch(clearContactDetails());
          // navigate("/contact");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  const gridRef = useRef<any>(null);

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div
        style={{
          position: "relative",
          marginBottom: "10px",
          padding: "10px",
          border: "1px solid lightgray",
          borderRadius: "5px",
          boxShadow: "0 0 10px gainsboro",
        }}
      >
        <ContactFilter />
      </div>
      <Form
        // onSubmit={handleSubmit}
        initialValues={{ User: "", SortType: "CreatedOnDesc" }}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "end",
                padding: "10px",
                border: "1px solid lightgray",
                borderRadius: "5px",
                boxShadow: "0 0 10px gainsboro",
              }}
            >
              <Field
                wrapperClassName="m-0"
                wrapperStyle={{ minWidth: 300 }}
                name="User"
                label="User"
                placeholder="Select User"
                component={FormSelectionField}
                options={UserList?.map((user: IUser) => ({
                  value: user?.ID,
                  label: `${user?.FirstName} ${user?.LastName}`,
                }))}
              />
              <Button
                themeColor={"primary"}
                fillMode={"solid"}
                disabled={
                  !formRenderProps.valueGetter("User") ||
                  rowSelectionModel?.length < 1
                }
                onClick={() =>
                  handleSubmit(
                    { User: formRenderProps.valueGetter("User") },
                    formRenderProps
                  )
                }
              >
                Assign
              </Button>
            </div>

            <div
              style={{
                marginTop: 10,
                padding: "10px",
                border: "1px solid lightgray",
                borderRadius: "5px",
                boxShadow: "0 0 10px gainsboro",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 10,
                  justifyContent: "space-between",
                }}
                className="mt-1 mb-3"
              >
                <div className="d-flex gap-2">
                  <Button
                    themeColor={"primary"}
                    fillMode={activeTabIndex === 0 ? "solid" : "outline"}
                    onClick={() => handleTabChange(0)}
                  >
                    Overall Contacts
                  </Button>
                  <Button
                    themeColor={"primary"}
                    fillMode={activeTabIndex === 1 ? "solid" : "outline"}
                    onClick={() => handleTabChange(1)}
                  >
                    Un-Assigned
                  </Button>
                </div>
                <Field
                  wrapperClassName="m-0"
                  wrapperStyle={{ minWidth: 300 }}
                  name="SortType"
                  placeholder="Sort Contacts"
                  component={FormSelectionField}
                  onChange={(e) => handleSortChange(e?.value)}
                  options={CONTACTSORTTYPE?.map((sortType: any) => ({
                    value: sortType.value,
                    label: sortType.label,
                  }))}
                />
              </div>
              <KendoGrid
                style={{ maxHeight: "calc(100vh - 380px)" }}
                className="responsive-table"
                filterable={false}
                dataItemKey={DATA_ITEM_KEY}
                data={ContactList?.map((item: any) => ({
                  ...item,
                  [SELECTED_FIELD]: selectedState[idGetter(item)],
                }))}
                total={ContactList[0]?.ItemCount || ContactList?.length}
                skip={currentPage * pageLimit}
                take={pageLimit}
                selectedField={SELECTED_FIELD}
                pageable={{
                  buttonCount: 5,
                  pageSizes: [5, 10, 50, 100, 500],
                  pageSizeValue: pageLimit,
                  type: "input",
                }}
                onSelectionChange={onSelectionChange}
                onHeaderSelectionChange={onHeaderSelectionChange}
                onPageChange={pageChange}
                cells={{
                  headerCell: HeaderCustomCell,
                  data: MyDataCustomCell,
                }}
                reorderable={true}
              >
                <Column
                  filterable={false}
                  field={SELECTED_FIELD}
                  width={50}
                  headerSelectionValue={
                    dataState?.findIndex(
                      (item: any) => !selectedState[idGetter(item)]
                    ) === -1
                  }
                />
                <Column
                  field="Name"
                  title="Name"
                  width={300}
                  cells={{
                    data: (props: any) => (
                      <td>
                        {isEditAccess ? (
                          <div
                            className="hoverableName"
                            onClick={() => {
                              isEditBtnRef.current = true;
                              navigate("/contact/edit", {
                                state: {
                                  ContactID: props.dataItem?.ID,
                                },
                              });
                            }}
                          >
                            {props.dataItem?.FirstName}{" "}
                            {props.dataItem?.LastName}
                          </div>
                        ) : (
                          <div className="normalName">
                            <p className="m-0">
                              {props.dataItem?.FirstName}{" "}
                              {props.dataItem?.LastName}
                            </p>
                          </div>
                        )}
                      </td>
                    ),
                  }}
                />
                <Column field="MobileNo" title="Mobile No." width={200} />
                <Column field="EmailID" title="Email ID" width={200} />
                <Column
                  field="ContactType"
                  title="Contact Type"
                  width={150}
                  cells={{
                    data: (props: any) => (
                      <td className="text-center fw-bold">
                        {props.dataItem?.ContactType}
                      </td>
                    ),
                  }}
                />
                <Column field="ContactOwnerName" title="Owner" width={200} />
                <Column
                  field="ID"
                  title="Status"
                  cells={{ data: MyActiveInActtiveCommandCell }}
                  width={"90px"}
                  filterable={false}
                  locked={true}
                />
                <Column
                  field="ID"
                  title="Details"
                  cells={{ data: ListingButtonCell }}
                  width={"190px"}
                  filterable={false}
                  locked={true}
                />
                {(isEditAccess || isDeleteAccess) && (
                  <Column
                    field="ID"
                    title="Actions"
                    cells={{ data: MyEditCommandCell }}
                    width={"110px"}
                    filterable={false}
                    locked={true}
                  />
                )}
              </KendoGrid>
            </div>
          </FormElement>
        )}
      />
    </>
  );
};

const BulkUploadContactDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const ContactFilterDetails = useAppSelector(
    (state) => state.contact.ContactFilterDetails
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const loading = useAppSelector((state) => state.contact.bulkUploadLoading);

  const handleSubmit = async (values: any) => {
    const formData = new FormData();
    formData.append("file", values?.ContactDocument[0]?.getRawFile());

    dispatch(bulkUploadContacts(formData)).then((res: any) => {
      if (res?.payload?.Status === 200) {
        dispatch(closeDialog());
        dispatch(
          getAllContacts({
            ...ContactFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          })
        );
      }
    });
  };

  return (
    <>
      {dialogName === "bulkUploadContact" && (
        <AppDialog>
          <>
            {loading && <LoadingPanel gridRef={gridRef} />}
            <Form
              onSubmit={handleSubmit}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ minWidth: 500 }}>
                  <GridLayout>
                    <GridLayoutItem className="position-relative">
                      <Typography.h4 className="typography-head">
                        {"Bulk Upload Contacts"}
                      </Typography.h4>
                      <IconButton
                        className="typography-dialog-close-icon"
                        type="button"
                        fillMode={"flat"}
                        themeColor={"dark"}
                        style={{ marginRight: 4, top: 7 }}
                        onClick={() => dispatch(closeDialog())}
                        icon={RxCross1}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="ContactDocument"
                        type="file"
                        filetype="file"
                        label="Contacts File"
                        accept=".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        multiple={false}
                        component={FormFileUpload}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 20,
                      }}
                    >
                      <Button
                        themeColor={"primary"}
                        fillMode={"solid"}
                        style={{ marginRight: 10 }}
                        onClick={() => window.open(contactSample)}
                      >
                        Show Sample
                      </Button>
                      <div>
                        <DialogCloseButton themeColor="primary" />
                        <ButtonWithLoading
                          label={"Upload"}
                          type="submit"
                          disabled={!formRenderProps.allowSubmit || loading}
                          loading={loading}
                        />
                      </div>
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};

const ExcelDownloadDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const loading = useAppSelector((state) => state.contact.ContactLoading);
  const isExcelAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS
  );
  const UserList = useAppSelector((state) => state.user.UserList);

  const handleSubmit = async (values: any) => {
    const payload = {
      FromDate: values?.FromDate ? values.FromDate : "",
      ToDate: values?.ToDate ? values.ToDate : "",
      ContactType: values?.ContactType ? values.ContactType : "",
      ContactOwner: values?.ContactOwner ? values.ContactOwner : "",
      AssignedUser: values?.AssignedUser ? values.AssignedUser : "",
    };
    const response = await dispatch(downloadContactExcel(payload));

    if (response.meta.requestStatus === "fulfilled" && response.payload) {
      const byteArray = response.payload;

      const blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "contactlist.xlsx");
    }
  };

  return (
    <>
      {dialogName === "filterforexceldownload" && (
        <AppDialog>
          <>
            {loading && <LoadingPanel gridRef={gridRef} />}
            <Form
              onSubmit={handleSubmit}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ minWidth: 600 }}>
                  <GridLayout
                    cols={[{ width: "49.5%" }, { width: "49.5%" }]}
                    gap={{ rows: 10, cols: 10 }}
                  >
                    <GridLayoutItem colSpan={2} className="position-relative">
                      <Typography.h4 className="typography-head">
                        {"Filter crieteria for excel downoad"}
                      </Typography.h4>
                      <IconButton
                        className="typography-dialog-close-icon"
                        type="button"
                        fillMode={"flat"}
                        themeColor={"dark"}
                        style={{ marginRight: 4, top: 7 }}
                        onClick={() => dispatch(closeDialog())}
                        icon={RxCross1}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"FromDate"}
                        label="From Date"
                        format="dd/MM/yyyy"
                        component={FormDatePicker}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"ToDate"}
                        label="To Date"
                        format="dd/MM/yyyy"
                        validator={requiredValidator}
                        astrike={true}
                        disabled={!formRenderProps.valueGetter("FromDate")}
                        component={FormDatePicker}
                        minDate={moment(
                          formRenderProps.valueGetter("FromDate")
                        ).toDate()}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={2}>
                      <Field
                        name={"ContactType"}
                        label={"Contact Type"}
                        placeholder="i.e. B2B"
                        component={FormSelectionField}
                        options={CONTACTTYPE?.map((initial: any) => {
                          return {
                            value: initial?.value,
                            label: initial?.label,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"ContactOwner"}
                        label={"Contact Owner"}
                        placeholder="Select Contact Owner"
                        component={FormSelectionField}
                        options={UserList?.map((user: IUser) => {
                          return {
                            value: `${user?.FirstName} ${user?.LastName}`,
                            label: `${user?.FirstName} ${user?.LastName}`,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"AssignedUser"}
                        label={"Assigned User"}
                        placeholder="Select Assigned User"
                        component={FormSelectionField}
                        options={UserList?.map((user: IUser) => {
                          return {
                            value: `${user?.FirstName} ${user?.LastName}`,
                            label: `${user?.FirstName} ${user?.LastName}`,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 20,
                      }}
                    >
                      <div>
                        <DialogCloseButton themeColor="primary" />
                        {isExcelAccess && (
                          <Button
                            themeColor={"primary"}
                            fillMode={"solid"}
                            type="submit"
                            style={{ marginRight: 10 }}
                            disabled={loading}
                          >
                            {loading ? (
                              <div
                                role="status"
                                className="flex items-center gap-2"
                              >
                                <svg
                                  aria-hidden="true"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    color: "white",
                                    fill: "var(--brand)",
                                    animation: "spin 1s linear infinite",
                                  }}
                                  viewBox="0 0 100 101"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="#1a5490"
                                  />
                                </svg>
                                <span className="sr-only">Loading...</span>
                              </div>
                            ) : (
                              "Download"
                            )}
                          </Button>
                        )}
                      </div>
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};

const DeleteContactDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const ContactID = useAppSelector((state) => state.contact.ContactID);
  const ContactFilterDetails = useAppSelector(
    (state) => state.contact.ContactFilterDetails
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteContact(ID));
      if (response.meta.requestStatus === "fulfilled") {
        dispatch(closeDialog());
        dispatch(clearContactID());
        dispatch(
          getAllContacts({
            ...ContactFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          })
        );
      } else {
        dispatch(closeDialog());
        dispatch(clearContactID());
        dispatch(
          getAllContacts({
            ...ContactFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          })
        );
      }
    }
  };
  return (
    <>
      {dialogName === "deleteContact" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Contact?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Contact?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(ContactID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default Contact;
